export const FREE_PRICING_TYPE = 'FREE';

export const isFreeEdition = (pricingType: string) => {
  if (!pricingType) {
    return false;
  }
  return pricingType.toUpperCase() === FREE_PRICING_TYPE;
};
